import React, { useState, useRef, useEffect } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { PopupMenu } from 'quantux-ui';
import { gray, blue, yellow } from '../../theme';

const AccessOption = (props) => {
  const [isPopupMenuOpen, setIsPopupMenuOpen] = useState(false);
  const [activeText, setActiveText] = useState('');

  // -- Styles ----------------------------------------------------------
  const styles = StyleSheet.create({
    popupMenuContainer: {
      background: 'black',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    menuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0',
      background: blue[900]
    },
    selectedOption: {
      fontSize: '14px',
      fontWeight: '700',
      color: props.showWarning ? yellow[500] : blue[400]
    }
  });

  useEffect(() => {
    if (props.permission === 0) {
      setActiveText('No Access');
    } else if (props.permission === 4) {
      setActiveText('Read');
    } else {
      setActiveText('Read/Write');
    }
    console.log(`${props.text} = ${props.permission}`);
  }, [props.permission]);

  // -- Refs ------------------------------------------------------------
  const popupRef = useRef();

  // -- Dynamic menu top to render the acees options menu in visible area
  let menuTop = 28;
  if (popupRef.current) {
    if (window.innerHeight - popupRef.current.getBoundingClientRect().top >= 150) { // was 400
      menuTop = 0;
    } else {
      menuTop = -120;
    }
  }

  return (
    <div className={props.className}>
      <div
        className='pl-2 pr-2 fx fx__v-center'
        style={{
          height: '40px',
          background: gray[600],
          justifyContent: 'space-between'
        }}
      >
        {/* ---- Left Part ---- */}
        <div className='fx fx__v-center'>
          {props.svgIcon || <i className='fa fa-user fa-2x' />}
          <div className='ml-2'>{props.text}</div>
        </div>
        {/* ---- Right Part ---- */}
        <div ref={popupRef} className='fx fx__v-center' style={{ position: 'relative' }}>
          <div className={`fx fx__v-center ${css(styles.selectedOption)}`}>
            {props.showWarning &&
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none" className='mr-2'>
                <path fill="#FF0" fillRule="evenodd" d="M.162 11.785a1 1 0 0 0 .84 1.543h13.664a1 1 0 0 0 .84-1.543L8.673 1.226a1 1 0 0 0-1.679 0L.162 11.786Zm8.668-.32a.996.996 0 1 1-1.993 0 .996.996 0 0 1 1.993 0Zm-.997-1.874c.55 0 .997-.446.997-.996V4.609a.996.996 0 1 0-1.993 0v3.986c0 .55.446.996.996.996Z" clipRule="evenodd" />
              </svg>
            }
            <div>
              {activeText}
            </div>
          </div>
          <div className={`ml-1 ${css(styles.selectedOption)}`}>
            <i
              className={`fa ${isPopupMenuOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}
              onClick={() => setIsPopupMenuOpen(!isPopupMenuOpen)}
            />
          </div>
          <PopupMenu
            top={menuTop}
            right={1}
            visible={isPopupMenuOpen}
            parent={popupRef}
            position="absolute"
            onOutsideClick={() => { setIsPopupMenuOpen(false); }}
          >
            <div className={css(styles.popupMenuContainer)}>
              <div
                className={`m-item ${activeText === 'No Access' ? 'active' : ''} ${css(styles.menuItem)}`}
                style={{ display: props.disableNoAccess ? 'none' : '' }}
                onClick={() => {
                  setIsPopupMenuOpen(false);
                  props.onChange(0);
                }}
              >
                <div>No Access</div>
              </div>
              <div
                className={`m-item ${activeText === 'Read' ? 'active' : ''}  ${css(styles.menuItem)}`}
                onClick={() => {
                  setIsPopupMenuOpen(false);
                  props.onChange(4);
                }}
              >
                <div>Read</div>
              </div>
              <div
                className={`m-item ${activeText === 'Read/Write' ? 'active' : ''} ${css(styles.menuItem)}`}
                onClick={() => {
                  setIsPopupMenuOpen(false);
                  props.onChange(6);
                }}
              >
                <div>Read/Write</div>
              </div>
            </div>
          </PopupMenu>
        </div>
      </div>
    </div>
  );
};

AccessOption.defaultProps = {
  className: '',
  disableNoAccess: false,
  showWarning: false
};
export default AccessOption;
